import { withModifiers as _withModifiers, withKeys as _withKeys, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, Teleport as _Teleport, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["contenteditable"]
const _hoisted_2 = {
  key: 0,
  class: "native-input__error-wrap"
}
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      _ctx.showBorder ? 'native-input-border' : 'native-input',
      'parent-box row no-wrap',
      { 'is-editable': _ctx.editOnClick && !_ctx.disabledField },
      { 'native-input--underline': _ctx.underlineEdit },
      { 'native-input--empty-warning': _ctx.isValidationWarning },
      { 'native-input--editing': _ctx.editingNow },
      { 'native-input--break-anywhere': _ctx.breakAnywhere }
    ])
  }, [
    _createElementVNode("div", {
      class: "inner-editable",
      ref: "editable_field",
      contenteditable: _ctx.isContentEditable,
      onDragstart: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
      onKeydown: [
        _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onEnter && _ctx.onEnter(...args)), ["enter"])),
        _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleKeydownUnified && _ctx.handleKeydownUnified(...args)))
      ],
      onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onBlur && _ctx.onBlur(...args))),
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args))),
      onInput: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onInput && _ctx.onInput(...args)))
    }, null, 40, _hoisted_1),
    (_ctx.isValidationWarning)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          _createElementVNode("img", {
            src: _ctx.errorCircleSvg,
            class: "native-input__error-icon"
          }, null, 8, _hoisted_3)
        ]))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.isValidationWarning)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "native-input__error-tooltip",
            style: _normalizeStyle(_ctx.tooltipStyle)
          }, _toDisplayString(_ctx.validationWarningText), 5))
        : _createCommentVNode("", true)
    ])),
    (
        _ctx.showClearIcon ||
        (this.editingNow &&
          _ctx.realTimeText.length &&
          (_ctx.inputType == 'text' || _ctx.realTimeText != '0'))
      )
      ? (_openBlock(), _createElementBlock("span", {
          key: 1,
          class: "native-input__clear-wrap",
          onMousedown: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["prevent"])),
          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onClear && _ctx.onClear(...args)))
        }, [
          _createVNode(_component_q_icon, {
            name: "arrow_back",
            size: "18px",
            class: "pointer hover-green target-icon native-input__clear-icon",
            style: {"align-self":"baseline","color":"#D2D2D2"}
          }),
          _createVNode(_component_q_tooltip, {
            delay: 300,
            anchor: "top middle",
            self: "center middle"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('clear_field')), 1)
            ]),
            _: 1
          })
        ], 32))
      : _createCommentVNode("", true)
  ], 2))
}